import React from 'react';
import { useMediaQuery } from 'react-responsive';

interface Props {
	children: React.ReactNode;
}

export const Mobile: React.FC<Props> = ({ children }) => {
	const isMobile = useMediaQuery({
		query: '(max-width:768px)',
	});
	return <>{isMobile && children}</>;
};

export const Tablet: React.FC<Props> = ({ children }) => {
	const isTablet = useMediaQuery({
		query: '(min-width: 769px) and (max-width:1023px)',
	});
	return <>{isTablet && children}</>;
};

export const Desktop: React.FC<Props> = ({ children }) => {
	const isDesktop = useMediaQuery({
		query: '(min-width:1024px)',
	});
	return <>{isDesktop && children}</>;
};
